export const LAYOUT_TYPE = /** @type {const} */ ({
  DEFAULT: 'DEFAULT',
  DEFAULT_STICKY: 'DEFAULT_STICKY', // Default but sticky and always show header/footer.
  EBOOK: 'EBOOK',
  QUIZ: 'QUIZ',
  EXTERNAL_VIDEO_PLAYER: 'EXTERNAL_VIDEO_PLAYER',
});
/** @typedef {typeof LAYOUT_TYPE[keyof LAYOUT_TYPE]} LayoutType  */

export const LEARNING_MODE = /** @type {const} */ ({ DEFAULT: 'DEFAULT' });
/** @typedef {string | null} LearningMode  */
